import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Member} from '../member';
import {MemberService} from '../member.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {RecordDataComponent} from "../../../../components/record-data";
import {Tax} from "../../taxes/tax";
import {AppArcComponent} from '../../../../components/app-arc';
import {OrganizationService} from '../../../setting/organization/organization.service';
import {OrganizationShowComponent} from "../../organization/organization-show/organization-show.component";
import {AccountsService} from '../../../fin/accounts/accounts.service';
import {CostcentersService} from '../../../fin/costcenters/costcenters.service';
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {CityService} from '../../cities/cities.service';
import {StoreService} from '../../stores/store.service';
import {UserService} from '../../../../services';
import {ClassificationsService} from '../../classifications/classifications.service';
import {BranchService} from '../../branches/branch.service';
import {ItemsShowComponent} from '../../items/items-show/items-show.component';
import {BranchesShowComponent} from '../../branches/branches-show/branches-show.component';
import {DepartmentsShowComponent} from '../../departments/departments-show/departments-show.component';
import {ClassificationsShowComponent} from '../../classifications/classifications-show/classifications-show.component';
import {UsersShowComponent} from '../../users/users-show/users-show.component';
import {ProcessesShowComponent} from '../../../management/processes/processes-show/processes-show.component';


@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule, MessagesModule,MyInputsModule,
        ReactiveFormsModule,
        ConfirmDialogModule,
        TranslateModule.forChild()
    ],
    declarations: [
        MembersShowComponent
    ],
    entryComponents: [
        MembersShowComponent
    ],
    exports: [],
    providers: [SharedService, MemberService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})
@Component({
    selector: 'app-members-show',
    templateUrl: './members-show.component.html',
    styleUrls: ['./members-show.component.scss'],
    providers: [MemberService, ConfirmationService, MessageService]
})


export class MembersShowComponent implements OnInit, AfterViewInit {

  id: string;
  member = new Member();
  filter: any;
  @Input() delId;
  @Input() scrId;
  @Input() oldData;
  @Input() newData;
  @Input() newDatap;
  @Input() modelName;
  modalRef: NgbModalRef;

  branchid_show:any;
  departmentid_show:any;
  categoryidshow:any;
  allclassifications: any[] = [];
  allprocces: any[] = [];
  allactions: any[] = [];
  allusers: any[] = [];
  alldepartments: any[] = [];
  allbranches: any[] = [];

  deletedrow: any[] = [];
  selectedrow: any[] = [];
  userCount: any[] = [];
  selectedUsers: string[] = [];
  selectedUsers_old: string[] = [];
  Selected_users: any[] = [];
  Selected_users_old: any[] = [];
  Selected_departments: any[] = [];
  Selected_departments_old: any[] = [];

  branches_enhance: any[] = [];
  departments_enhance: any[] = [];
  users_enhance: any[] = [];
  branchCount: any[] = [];
  Selected_branches: any[] = [];
  Selected_branches_old: any[] = [];
  selectedBranches: string[] = [];
  Departmentsonbranches: any = [];
  Departmentsonbranches_old: any = [];
  selectedDepartments: string[] = [];

  memberForm: FormGroup;
  private sub: any;
  msgs: Message[] = [];
  statusVal = [{'val': 1, 'title': 'Active'}, {'val': 2, 'title': 'Inactive'}];
  WorkpolicyVal = [
    {'val':1,'title':'Dynamic'},
    {'val':2,'title':'Manual'}
  ];
  Distribution_mechanismVal = [
    {'val':1,'title':'Onteam'},
    {'val':2,'title':'Ontime'}
  ];

  row_id: any;
  restoreInv: any;

  private _editButton: any;
  private _deleteButton: any;
  private _searchButton: any;
  private _newButton: any;
  private _printButton: any;
  hiddenFields: any[] = [];

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private memberService: MemberService,
                private classificationsService: ClassificationsService,
                private branchService: BranchService,
                private userService: UserService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private organizationService: OrganizationService,
                private messageService: MessageService) {
                this.msgs = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));

        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
      this.sharedservice.setItemShow(MembersShowComponent);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},
        ]);
        this.sharedservice.setModelName('members');
    }

    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();

                return true;
            }
        };
        JSON.parse(localStorage.getItem('filter'));

        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.member;
        modalRef.componentInstance.rowId = '';

    }



  showprocess(id){
    console.log(id);
    const options: NgbModalOptions = {

      beforeDismiss: () => {
        console.log("before dismiss");
        return true;
      }
    };
    this.modalRef = this.modalService.open(ProcessesShowComponent, options);
    this.modalRef.componentInstance.scrId = id;

    this.modalRef.result.then(() => {
      this.activeModal.dismiss('done');
    }, () => {
      console.log('Backdrop click')
    });
  }


  showUser(id){
    console.log(id);
    const options: NgbModalOptions = {

      beforeDismiss: () => {
        console.log("before dismiss");
        return true;
      }
    };
    this.modalRef = this.modalService.open(UsersShowComponent, options);
    this.modalRef.componentInstance.scrId = id;

    this.modalRef.result.then(() => {
      this.activeModal.dismiss('done');
    }, () => {
      console.log('Backdrop click')
    });
  }


  showParenpranch() {

      const options: NgbModalOptions = {

        beforeDismiss: () => {
          console.log("before dismiss");
          return true;
        }
      };
      this.modalRef = this.modalService.open(BranchesShowComponent, options);
      this.modalRef.componentInstance.scrId = this.branchid_show;

      this.modalRef.result.then(() => {
        this.activeModal.dismiss('done');
      }, () => {
        console.log('Backdrop click')
      });
  }
   showParendepartment() {

      const options: NgbModalOptions = {

        beforeDismiss: () => {
          console.log("before dismiss");
          return true;
        }
      };
      this.modalRef = this.modalService.open(DepartmentsShowComponent, options);
      this.modalRef.componentInstance.scrId = this.departmentid_show;

      this.modalRef.result.then(() => {
        this.activeModal.dismiss('done');
      }, () => {
        console.log('Backdrop click')
      });
  }

  showParenclassifications() {

    const options: NgbModalOptions = {

      beforeDismiss: () => {
        console.log("before dismiss");
        return true;
      }
    };
    this.modalRef = this.modalService.open(ClassificationsShowComponent, options);
    this.modalRef.componentInstance.scrId = this.categoryidshow;

    this.modalRef.result.then(() => {
      this.activeModal.dismiss('done');
    }, () => {
      console.log('Backdrop click')
    });
  }

    ngAfterViewInit() {
      if(!this.scrId && !this.oldData) {

            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._searchButton = document.getElementById('searchButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');

            if (this._editButton) {
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/members/edit', this.id]);
                });
            }
            if (this._deleteButton) {
                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteMember(this.member);
                });
            }
            if (this._newButton) {
                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/members']);
                });
            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/members/search']);
                });
            }
        }
    }

    ngOnInit() {
      this.branchService.getAllDepartments().subscribe(
        allbranches => {
          this.alldepartments = allbranches.departmentslist;
          this.departments_enhance = allbranches.departmentstable;
        });

      this.branchService.getAllBranches().subscribe(
        allbranches => {
          this.allbranches = allbranches.brancheslist;
        });



      this.userService.getAllUsers().subscribe(
        group => {
          this.allusers = group.userslist;
        });

      this.classificationsService.getAllClassifications().subscribe(
        group => {
          this.allclassifications = group.categorieslist;
        });

      this.memberService.getAllProcess().subscribe(
        group => {
          this.allprocces = group.proceslist;
        });

      this.memberService.getAllActions('0').subscribe(
        group => {
          this.allactions = group.actionlist;
        });


        this.msgs=[];
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

      this.memberForm =new FormGroup({
        name: new FormControl({value: '', disabled: true}, Validators.required),
        department_id: new FormControl({value: '', disabled: true}),
        branch_id: new FormControl({value: '', disabled: true}),
        distribution_system: new FormControl({value: '', disabled: true}, Validators.required),
        distribution_mechanism: new FormControl({value: '', disabled: true}, Validators.required),
        category_id: new FormControl({value: '', disabled: true}, Validators.required),

      });



        if (this.id) {
          this.msgs=[];
          this.activeModal.dismiss('');
          this.oldData = false;
          this.newData = false;
          this.newDatap = true;

          this.delId = false;
          localStorage.removeItem('filter');
          const msg = JSON.parse(localStorage.getItem('showMessages'));
          if (msg) {
              localStorage.removeItem('showMessages');
              this.msgs = msg;
              this.msgs=[];
          }
          this.memberService.getById(this.id).subscribe(
            member => {
              this.id = member.id;
              this.member = member;
              this.memberForm.patchValue({
                name: member.name,
                department_id: member.department_id,
                branch_id: member.branch_id,
                distribution_system: member.distribution_system,
                distribution_mechanism: member.distribution_mechanism,
                category_id: member.category_id,

              });
              this.branchid_show = member.branch_id;
              this.departmentid_show = member.department_id;
              this.categoryidshow = member.category_id;

              this.userCount = Array(member.users.length).fill(2);
              //let indx = 0;
              this.selectedUsers = [];
              this.Selected_users = [];
              for(let user of member.users) {
                let iserte = {value: user.id, type: user.pivot.type};
                //indx++;
                this.Selected_users.push(iserte);
                this.selectedUsers.push(user.id);
              }

              this.branchCount = Array(member.aproceses.length).fill(2);
              let indx = 0;
              this.selectedBranches = [];
              this.Selected_branches = [];
              this.Selected_branches = member.aproceses;
              console.log(this.Selected_branches);
              for (var x = 0; x < this.Selected_branches.length; x++) {
                console.log(this.Selected_branches[x]);
                this.selectedBranches.push(this.Selected_branches[x].value);
                this.Selected_departments[x] = {value :this.Selected_branches[x].action_id , inx: x};

                this.selectedDepartments[x] = this.Selected_branches[x].action_id;
                this.Departmentsonbranches[x] = this.Selected_branches[x].departmentsb;

              }

              for (var x = 0; x < this.Selected_branches_old.length; x++) {
                console.log(this.Selected_branches_old[x]);
                this.Departmentsonbranches_old[x] = this.Selected_branches_old[x].departmentsb;

              }
              console.log(this.selectedDepartments);
              console.log(this.Departmentsonbranches);

            }, error => {
              console.log(error);
            }
          );
        }
        if (this.scrId) {
            this.oldData = false;
            this.newData = false;

            this.delId = false;

          this.memberService.getById(this.scrId).subscribe(
            member => {
              this.id = member.id;
              this.member = member;
              this.memberForm.patchValue({
                name: member.name,
                department_id: member.department_id,
                branch_id: member.branch_id,
                distribution_system: member.distribution_system,
                distribution_mechanism: member.distribution_mechanism,
                category_id: member.category_id,

              });
              this.branchid_show = member.branch_id;
              this.departmentid_show = member.department_id;
              this.categoryidshow = member.category_id;

              this.userCount = Array(member.users.length).fill(2);
              //let indx = 0;
              this.selectedUsers = [];
              this.Selected_users = [];
              for(let user of member.users) {
                let iserte = {value: user.id, type: user.pivot.type};
                //indx++;
                this.Selected_users.push(iserte);
                this.selectedUsers.push(user.id);
              }

              this.branchCount = Array(member.aproceses.length).fill(2);
              let indx = 0;
              this.selectedBranches = [];
              this.Selected_branches = [];
              this.Selected_branches = member.aproceses;
              console.log(this.Selected_branches);
              for (var x = 0; x < this.Selected_branches.length; x++) {
                console.log(this.Selected_branches[x]);
                this.selectedBranches.push(this.Selected_branches[x].value);
                this.Selected_departments[x] = {value :this.Selected_branches[x].action_id , inx: x};

                this.selectedDepartments[x] = this.Selected_branches[x].action_id;
                this.Departmentsonbranches[x] = this.Selected_branches[x].departmentsb;

              }

              for (var x = 0; x < this.Selected_branches_old.length; x++) {
                console.log(this.Selected_branches_old[x]);
                this.Departmentsonbranches_old[x] = this.Selected_branches_old[x].departmentsb;

              }
              console.log(this.selectedDepartments);
              console.log(this.Departmentsonbranches);

            }, error => {
              console.log(error);
            }
          );

        }
        if (this.delId) {
          this.oldData = false;
          this.newData = false;
          this.newDatap = !this.newDatap ;
          this.memberService.getTrashedById(this.delId).subscribe(
            member => {
                this.id = member.id;
                this.member = member;
                this.memberForm.patchValue({
                  id: member.id,
                  fax: member.fax,
                  name: member.name,
                  status: member.status,
                  city_id: member.city_id,
                  address: member.address,
                  store_id: member.store_id,
                  telephone: member.telephone,
                  manager_id: member.manager_id,
                  currency_id: member.currency_id,
                });
            }, error => {
                console.log(error);
            }
          );
        }

        if (this.oldData && this.newData) {
          console.log(this.oldData);
          console.log(this.newData);
          this.member = this.newData;
          this.memberForm.patchValue({
            id: this.newData.id,
            department_id: this.newData.department_id,
            name: this.newData.name,
            branch_id: this.newData.branch_id,
            distribution_system: this.newData.distribution_system,
            distribution_mechanism: this.newData.distribution_mechanism,
            category_id: this.newData.category_id,
          });
          //this.Selected_users = this.newData.users;
          //this.Selected_users_old = this.oldData.users;
          this.branchid_show = this.newData.branch_id;
          this.departmentid_show = this.newData.department_id;
          this.categoryidshow = this.newData.category_id;
          this.row_id = this.newData.row_id;

          this.Selected_branches = this.newData.aproceses;
          //this.Selected_branches_old = this.oldData.aproceses;
          this.restoreInv = this.oldData;


          this.restoreInv.users = JSON.stringify(this.oldData.users);
          this.restoreInv.process = JSON.stringify(this.oldData.proceses);

          for(let user of this.newData.users) {
            let iserte = {value: user.id, type: user.pivot.type};
            //indx++;
            this.Selected_users.push(iserte);
            this.selectedUsers.push(user.id);
          }
          for(let user of JSON.parse(this.oldData.users)) {
            let iserte = {value: user.id, type: user.pivot.type};
            //indx++;
            this.Selected_users_old.push(iserte);
            this.selectedUsers_old.push(user.id);
          }

          for(let branch of this.oldData.aproceses ) {
            let iserte = {value: branch.id, action_id:branch.action_id,currentdb:branch.currentdb} ;
            //indx++;
            this.Selected_branches_old.push(iserte);
          }

          for (var x = 0; x < this.oldData.aproceses.length; x++) {

            this.Selected_departments_old[x] = {value :this.Selected_branches_old[x].action_id , inx: x};

            this.Departmentsonbranches_old[x] = this.Selected_branches_old[x].departmentsb;

          }


          for (var x = 0; x < this.Selected_branches.length; x++) {
            console.log(this.Selected_branches[x]);
            this.selectedBranches.push(this.Selected_branches[x].value);
            this.Selected_departments[x] = {value :this.Selected_branches[x].action_id , inx: x};

            this.selectedDepartments[x] = this.Selected_branches[x].action_id;
            this.Departmentsonbranches[x] = this.Selected_branches[x].departmentsb;

          }







        }
    }

    fieldsControl(screen: string = '') {
        if (screen === '') {
            return;
        }
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (!userdata.fields) {
            this.hiddenFields = [];
        } else {
            this.hiddenFields = (userdata.fields.screens[screen]) ? userdata.fields.screens[screen] : [];
        }

    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('setting.members.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteMember(member: Member) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
              if (member) {
                this.memberService.delete(member.id).subscribe(
                  res => {
                    this.msgs = [];
                    if (res.result == false) {
                      this.msgs.push({
                        severity: 'error',
                        summary: '',
                        detail: this.translate.instant(res.message)
                      });
                    } else {
                      this.msgs.push({
                        severity: 'success',
                        summary: '',
                        detail: this.translate.instant('Delete completed')
                      });
                      setTimeout(() => {
                          this.router.navigate(['/members']);
                      }, 1000);
                    }
                    localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                  }
                );
              }
            }
        });
    }

    recoverEdit(member: Member) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (member) {
                    this.memberService.update(member).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/members/show', member.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.memberService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/members/list']);
                        }
                    );
                }
            }
        });
    }

    showattachement(row_id: string) {
        console.log(row_id)
        if (row_id) {
            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    // this.changePicUrl();
                    return true;
                }
            };
            const modalRef = this.modalService.open(AppArcComponent, options);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.screenName = this.modelName;
        }
    }

    showHistory(row_id: string) {
        if (row_id) {
            const modalRef = this.modalService.open(AppLogComponent);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.refShow = MembersShowComponent;

        }
    }


}



// WEBPACK FOOTER //
// ./src/app/views/setting/members/members-show/members-show.component.ts